import { Addresses } from '@/domain/addresses';
import { getChainConstant } from '@/domain/chain';
import useChainId from '@/hooks/useChainId';
import FloorV1TokenMerkleClaimAbi from '@/infrastructure/abis/FloorV1TokenMerkleClaim';
import { Address } from 'viem';
import { useReadContract } from 'wagmi';

const useClaimed = (recipient?: Address) => {
  const chainId = useChainId();

  return useReadContract({
    address: getChainConstant(Addresses, chainId, 'FloorV1TokenMerkleClaim'),
    abi: FloorV1TokenMerkleClaimAbi,
    functionName: 'claimed',
    args: [recipient as Address],
    query: {
      enabled: !!recipient,
    },
  });
};

export default useClaimed;
